<div *ngIf="!formElement.hidden" [ngClass]="rowClass">
  <!-- <div class="row"> -->
  <label [for]="formElement.name" [ngClass]="labelClass || 'col-2 col-form-label right-text'">
    {{label || formElement.label}}
    <span class="mandatoryColor"
      *ngIf="(label || formElement.label) && (required ||formElement.required || formElement.showAstrisk)">*</span>
    <!-- <span class="mandatoryColor" *ngIf="(label || formElement.label) && (required ||formElement.required) && !formElement.silentRequired">*</span> -->
  </label>
  <div [ngClass]="inputClass || 'col-10'">
    <!-- <input [disabled]="isDisabled()" (keydown)="onKeydown($event)" [attr.maxlength]="formElement.maxFieldLength" (blur)="onBlur()"
       [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default" [id]="formElement.id || formElement.name || name" [type]="type" [placeholder]="formElement.readOnly ? '' : (placeholder || formElement.placeholder)"
       [name]="name ||formElement.name" [ngModel]="value" (ngModelChange)="onChange()"> -->
    <span
      [class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default">{{formElement.name !== 'startDate' ? (value ? value : 'N/A') : (value | date: 'dd/MM/yyyy')}}</span>
    <span *ngIf="formElement.metainfo" class="m-form__help">
      {{formElement.metainfo.toString()}}
    </span>
    <span *ngIf="formElement.metaLink" (click)="formElement.metaLink?.onClick()" class="m--font-info link-text">
      {{formElement.metaLink?.text}}
    </span>
  </div>
</div>